import lupa from './Icon awesome-search.svg'
import './search.css'

export function Search(props) {
    function searchHandler({ target }) {
        if (target.value !== "") {
            const newData = props.initialData.filter((value) => {
                return Object.values(value)
                    .join("")
                    .toLowerCase()
                    .includes(target.value.toLowerCase());
            });

            props.set(newData);
        } else {
            props.set(props.initialData);
        }
    }
    return (
        <div style={props.style} className='content-input-search'>
            <img src={lupa} alt='lupa' />
            <input onChange={searchHandler} className='montserrat' type='text' placeholder={props.placeholder} />
        </div>
    )
}